import { Component, OnInit, ViewChild, AfterViewInit, ElementRef, OnDestroy } from '@angular/core';
import { MatPaginator, MatSort, MatDialog } from '@angular/material';
import { debounceTime, distinctUntilChanged, tap, catchError } from 'rxjs/operators';
import { fromEvent, merge } from 'rxjs';
import { UserStatusName } from 'src/app/entities/util';
import { SharedService } from 'src/app/services/sharedService';
import { AtomDataSource } from 'src/app/services/atomTable.datasource';
import { UserDialogComponent } from './dialog/user-dialog/user-dialog.component';
import { UserService } from 'src/app/services/user.service';
import { ConfirmationDialogComponent } from '../dialogs/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'atom-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit, AfterViewInit, OnDestroy {


  subscriptionUpdateUser: any;
  subscriptionDeactivateUser: any;
  subscriptionActivateUser: any;
  subscriptionDeleteUser: any;

  displayedColumns: string[] = ['_id', 'role', 'division', 'status', 'action'];
  dataSource: AtomDataSource;
  statusNames = UserStatusName
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild('input_search', { static: false }) input: ElementRef;

  constructor( public dialog: MatDialog, public userService: UserService,public sharedService: SharedService) {

  }

  ngOnInit() {
    this.dataSource = new AtomDataSource(this.userService)
    this.subscriptionUpdateUser = this.sharedService.updateUserEmmitter.subscribe(val => {
      if (val) {
        this.userService.updateResource('user', val).subscribe(res => {
          this.loadUserTable();
        })
   
        
      }
    })
    this.subscriptionDeactivateUser = this.sharedService.deactivateUserEmmitter.subscribe(val => {
      if (val) {
        this.userService.deactivateResource('user', val).subscribe(res => {
          this.loadUserTable();
        })
      }
    })

    this.subscriptionActivateUser = this.sharedService.activateUserEmmitter.subscribe(val => {
      if (val) {
        this.userService.activateResource('user', val).subscribe(res => {
          this.loadUserTable();
        })
      }
    })

    this.subscriptionDeleteUser = this.sharedService.deleteUserEmmitter.subscribe(val => {
      if (val) {
        this.userService.deleteResource('user', val).subscribe(res => {
          this.loadUserTable();
        })
      }
    })

  }

  ngAfterViewInit() {

    setTimeout(() => {
      this.dataSource.loadData('user', '', 'asc', 'name', 0, this.paginator.pageSize, {});

    }, 0)

    this.sort.sortChange.subscribe(() => {});

    fromEvent(this.input.nativeElement, 'keyup')
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        tap(() => {
          this.paginator.pageIndex = 0;
          this.loadUserTable();
        })
      )
      .subscribe();

    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        tap(() => this.loadUserTable())
      )
      .subscribe();

  }

  loadUserTable() {
    this.dataSource.loadData('user',
      this.input.nativeElement.value,
      this.sort.direction,
      this.sort.active,
      this.paginator.pageIndex,
      this.paginator.pageSize, {});
  }

  openUserDialog(user): void {
    const dialogRef = this.dialog.open(UserDialogComponent, {
      width: '600px', panelClass: 'custom-dialog-container',
      data: user
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  openDeleteDialog(user): void {
    user['class'] = 'USER';
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '600px', panelClass: 'custom-dialog-container',
      data: {obj:user, text: 'DIALOG.DELETE_CURRENT_USER', action: 'DELETE' }
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }

  ngOnDestroy() {
    if (this.subscriptionUpdateUser) this.subscriptionUpdateUser.unsubscribe();
    if (this.subscriptionDeactivateUser) this.subscriptionDeactivateUser.unsubscribe();
    if (this.subscriptionActivateUser) this.subscriptionActivateUser.unsubscribe();
    if (this.subscriptionDeleteUser) this.subscriptionDeleteUser.unsubscribe();
  }

}

